import { render, staticRenderFns } from "./onlineStudyDetails.vue?vue&type=template&id=18ae9729&scoped=true&"
import script from "./onlineStudyDetails.vue?vue&type=script&lang=js&"
export * from "./onlineStudyDetails.vue?vue&type=script&lang=js&"
import style0 from "./onlineStudyDetails.vue?vue&type=style&index=0&id=18ae9729&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae9729",
  null
  
)

export default component.exports